import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import pencil from '../../../../assets/certificates/Tables/pencil.svg'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import SectionContext from '../../../../contexts/SectionContext'
import CertificatesContext, { CertificateObject } from '../../../../contexts/CertificatesContext'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/table-style'
import { useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '..'
import ModalContext from '../../../../contexts/ModalContext'

const CertificatesTable: React.FC = () => {
  const { setTabIndex } = useOutletContext<CertificateOutletType>()
  const { allCertificates, setAllCertificates, setCertificate, setStructureData, certificatesTableQuantity } = useContext(CertificatesContext)
  const { setCertificatesSection } = useContext(SectionContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)

  useEffect(() => {
    setTabIndex(0)
  })
  
  useEffect(() => {
    const certificateUrl = process.env.REACT_APP_CERTIFICATES_BASE_URL

    axios 
    .get(`${certificateUrl}/certificate`, {
      params: {
        quantity: certificatesTableQuantity
      }
    })
    .then((response) => {
      setAllCertificates(response.data)
    })
    .catch((error) => {
      console.log('Ocorreu um erro ao obter os dados de certificados', error)
    })
    .finally(() => {
      console.log("Certificates have been loaded")
    })
  }, [certificatesTableQuantity])

  const handleEdit = (index: number) => {
    const selectedStructures = allCertificates[index].structures
    const selectedCertificate: CertificateObject = {
      id: allCertificates[index].id,
      type: allCertificates[index].type,
      material: allCertificates[index].material,
      profile: allCertificates[index].profile,
      heatNumber: allCertificates[index].heatNumber,
      standard: allCertificates[index].standard,
      conformation: allCertificates[index].conformation,
      heatTreatment: allCertificates[index].heatTreatment,
      mechanicalTest: allCertificates[index].mechanicalTest,
      nf: allCertificates[index].nf,
      date: allCertificates[index].date,
      description: allCertificates[index].description,
      customerCompany:allCertificates[index].customerCompany,
      supplierCompany:allCertificates[index].supplierCompany,
      structures: [],
      supplierFile: null
    }
    setStructureData(selectedStructures)
    setCertificate(selectedCertificate)
    setCertificatesSection('editCertificate')
  }
  
  const viewCertificate = (index:number) => {
    setCertificate(allCertificates[index])
    setModalActive(true)
    setModalSection('viewCertificate')
  }

  const columns = ["Fornecedor", "Cliente", /*"Tipo",*/ "Material", "Corrida", "Cód. Prod", "OP/OC", "Item", "Data"]

  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          {columns.map((item, colIndex) => (
            <Th key={colIndex}>{item}</Th>
          ))}
        </HeaderLine>
      </thead>
      <tbody>
        {allCertificates.slice(0, -1).map((item, rowIndex) => (
          <Tr key={rowIndex}>
            <Td className='notLast'> {item.material} </Td>
            <Td className='notLast'> {item.standard} </Td>
            <Td className='notLast'> {item.standard} </Td>
            <Td>
              {new Date(allCertificates[allCertificates.length - 1].date).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              })}
            </Td>
              {/* <FirstImageCell> 
                <ImageCellImg 
                  onClick={() => handleEdit(rowIndex)} 
                  src={pencil} 
                  alt='Pencil icon' 
                /> 
                </FirstImageCell>
              <SecondImageCell> 
                <ImageCellImg 
                  src={lookup} alt='Lookup icon' 
                  onClick={() => viewCertificate(rowIndex)}
                /> 
              </SecondImageCell> */}
          </Tr>
        ))}
        {allCertificates.length !== 0 &&
          <Tr>
            {/* <Td> {allCertificates[allCertificates.length-1].type} </Td> */}
            <Td> {allCertificates[allCertificates.length-1].material} </Td>
            <Td> {allCertificates[allCertificates.length-1].profile} </Td>
            <Td> {allCertificates[allCertificates.length-1].standard} </Td>
            <Td> {allCertificates[allCertificates.length-1].standard} </Td>
            <Td>
              {new Date(allCertificates[allCertificates.length - 1].date).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              })}
            </Td>
            {/* <FirstImageCell> 
              <ImageCellImg 
                onClick={() => handleEdit(allCertificates.length-1)} 
                src={pencil} 
                alt='Pencil icon'
              /> 
            </FirstImageCell> */}
            <TdButtons> 
              <img
                src={lookup} alt='Lookup icon'
                onClick={() => viewCertificate(allCertificates.length-1)}
              />
            </TdButtons>
          </Tr>
          }
      </tbody>
    </GlobalTable>
  )
}
export default CertificatesTable